<template>
  <NuxtLayout  >
    <PageRender
      :activeDetailData="activeDetailData"
      @contextmenu="onContextmenu"
      :edit="edit"
      :currentElementIndex="currentElementIndex"
      :currentElementIndexStr="currentElementIndexStr"
    />
  </NuxtLayout>
</template>

<script setup>
import { ref, computed, onMounted, watch, provide } from "vue";
import PageRender from "~/components/render/PageRender.vue"; 
import pageEditorUse, {
  getActiveDetailDataAsync
} from "~/composables/pageEditorUse";
import { useRoute, useState } from "#app";

const headers = useRequestHeaders();
const route = useRoute();
const currentPageIndex = ref(0);
const { data: activeDetailData } = await useAsyncData(
  "activeDetail",
  getActiveDetailDataAsync.bind(this,{headers,$fetch,
    id:route.query.id,
    url:route.query.url,
  },{currentPageIndex}),
  {
    watch: [route]
  }
);
let {
  onContextmenu,
  edit,
  currentElementIndex,
  currentElementIndexStr,
  getConfigJsonHook
} = pageEditorUse({
  activeDetailData,
  currentPageIndex
},{
  isPage:true
});
// 提供函数给子组件使用
provide("getConfigJson", getConfigJsonHook);
</script>

<style scoped>
</style>